import React from 'react'

import type { TELDAppSource } from '../../../types/tracking'
import { StatusIcon } from '../status-icon'
import { TrackingTimeDisplay } from '../tracking-time-display'

interface IELDAppTrackingInfo {
  trackingSourceData: TELDAppSource
}

/**
 * The component that displays the ELD app info in a tooltip
 */
export const ELDAppTrackingInfo = (props: IELDAppTrackingInfo) => {
  const { trackingSourceData } = props
  const trackingSourceMetadata = trackingSourceData?.metadata

  return (
    <div className="flex w-full flex-col space-y-2 items-start">
      <p className="text-md font-semibold ">{trackingSourceMetadata?.provider || 'ELD App'}</p>

      <p className="max-w-[400px] line-clamp-4 ">Device ID: {trackingSourceMetadata?.deviceID}</p>

      {!!trackingSourceData.locations?.length && trackingSourceData?.locations?.length > 0 && (
        <TrackingTimeDisplay
          filterReason={trackingSourceData.filterReason}
          lastLocationFetchedAt={trackingSourceData.lastLocationFetchedAt}
          lastLocationTimestamp={trackingSourceData.locations[trackingSourceData.locations.length - 1]?.timestamp}
          wrapper="p"
        />
      )}

      <div className="flex items-center space-x-2">
        <StatusIcon isPositive={Boolean(trackingSourceData.locations?.length)} />
        <span>Status: {trackingSourceData?.locations?.length ? 'Tracking' : 'Not tracking'}</span>
      </div>
    </div>
  )
}
